import { render } from "./sign-in-form.vue?vue&type=template&id=f991ae5c"
import script from "./sign-in-form.vue?vue&type=script&lang=ts"
export * from "./sign-in-form.vue?vue&type=script&lang=ts"
script.render = render

export default script